import { CELEB_SIDES } from '@/mocks/gossip';

export default function Sides() {
  return (
    <section className="border-b border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6">
          <h2 className="flex items-center gap-2 text-2xl font-bold tracking-wide text-foreground-950 md:text-[1.7rem]">
            <i className="ri-user-heart-line text-primary-500" aria-hidden="true" />
            人物档案 · 男星 / 女星
          </h2>
          <p className="mt-1.5 text-sm text-foreground-600">
            <b>婚内出轨男星</b>与<b>婚内出轨女星</b>分开归档，按人物与可信度整理，避免断章取义。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {CELEB_SIDES.map((side) => (
            <article
              key={side.side}
              className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50"
            >
              <div className="flex items-center gap-2 border-b border-background-200/60 bg-gradient-to-r from-background-50 to-secondary-100 px-5 py-3">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={side.side === '男星' ? 'ri-user-star-line' : 'ri-user-heart-line'} aria-hidden="true" />
                </span>
                <h3 className="text-lg font-bold tracking-wide text-foreground-950">
                  {side.side === '男星' ? '婚内出轨男星' : '婚内出轨女星'}
                </h3>
                <span className="ml-auto rounded-full bg-secondary-200 px-2 py-0.5 text-[11px] text-secondary-900">
                  在榜 {side.persons.length} 位
                </span>
              </div>
              <div className="p-5">
                <p className="text-xs leading-6 text-foreground-700">{side.intro}</p>
                <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4">
                  {side.persons.map((p) => (
                    <button
                      key={p}
                      type="button"
                      className="flex cursor-pointer flex-col items-center gap-1 rounded-lg border border-background-200/70 bg-background-100 py-3 transition-colors hover:border-primary-300 hover:bg-primary-100"
                    >
                      <span className="font-heading text-base tracking-[0.15em] text-foreground-900">{p}</span>
                      <span className="flex items-center gap-0.5 text-[10px] text-primary-600">
                        <i className="ri-fire-line" aria-hidden="true" />
                        热度在榜
                      </span>
                    </button>
                  ))}
                </div>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {side.tags.map((t) => (
                    <span key={t} className="whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-800">
                      #{t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}